import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { IconsModule } from '@progress/kendo-angular-icons';
import { commentIcon, SVGIcon } from '@progress/kendo-svg-icons';
import { Ticket } from '../../models/ticket.models';

@Component({
  selector: 'app-case-soc-button',
  standalone: true,
  imports: [CommonModule, ButtonsModule, IconsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button
      kendoButton
      class="cyflare-btn-primary cyflare-btn-lg w-100"
      [svgIcon]="chatIcon"
      (click)="openSocChat()"
    >
      Talk to SOC
    </button>
  `,
})
export class CaseSocButtonComponent {
  ticket = input.required<Ticket>();

  chatIcon: SVGIcon = commentIcon;

  openSocChat(): void {
    const sb = (window as unknown as Record<string, unknown>)['SupportBridge'] as
      | { open?: (context?: Record<string, string>) => void }
      | undefined;

    if (sb?.open) {
      sb.open({
        caseId: this.ticket().request_id,
        subject: this.ticket().subject,
        priority: this.ticket().priority,
      });
    } else {
      // Fallback — Support Bridge widget not loaded
      alert('Support Bridge is not available. Please contact your SOC team directly.');
    }
  }
}
